import { Component, OnInit } from '@angular/core';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import { ToplineService } from '../../service/topline.service';
import { ReportService } from '../../service/report.service';
import { RepoApiService } from '../../service/repo-api.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-download-setting',
  templateUrl: './download-setting.component.html',
  styleUrls: ['./download-setting.component.scss']
})
export class DownloadSettingComponent implements OnInit {
  public themeContainer:any [] = [];
  public downloadSetting:any = {};
  public errMsg:string;

  constructor(
    public eService:ExcelViewerService,
    public toplineService:ToplineService,
    public reportService:ReportService,
    private repoService:RepoApiService,
    private notifier:NotifierService
  ) { }

  ngOnInit(): void {
    this.getThemeData();
    this.getDownloadSettings();
  }

  ngOnDestroy():void{
    this.downloadSetting = this.eService.duplicatedownloadSetting;
  }

  getDownloadSettings(){
    this.downloadSetting = JSON.parse(JSON.stringify(this.eService.downloadSetting));
  }

  setRadioInput(type:string,val:any){
    this.downloadSetting['download'][type] = val;
  }






  getThemeData(){
    // this.themeContainer.push({id:1,name:'No Theme'});
    // this.themeContainer.push({id:2,name:'Theme-1'});
    // this.themeContainer.push({id:3,name:'Theme-2'});
    this.repoService.getDownloadSettingTheme().subscribe(
      result =>{
        if (result["status"] == 1) {
          this.themeContainer = result['result'];
        }else{
          this.notifier.notify("error","Something went wrong!")
        }
      }
    )
    

  }

  closeSettingDownloadComponent(){
    this.eService.isDownloadSettingComponent = false;
  }


  onSave(){
    if(this.validationData()){
      this.saveDownloadSettings();
      this.eService.isDownloadSettingComponent = false;
    }else{
      this.notifier.notify('error',this.errMsg)
    }
  }

  validationData(){
    if(!Object.keys(this.downloadSetting['download']).length ){
      this.errMsg = 'Please select all value';
      return 0;
    }else if(!this.downloadSetting['download']['headers']){
      this.errMsg = 'Please select header'
      return 0;
    }
    else if(!this.downloadSetting['download']['theme_id']){
      this.errMsg = 'Please select theme'
      return 0;
    }else{
      return 1;
    }
  }


  saveDownloadSettings(){
    let body = {
      file_id:this.toplineService.excelviewer_fileUUID,
      settings:{download:{headers:this.downloadSetting['download']['headers'],theme_id:this.downloadSetting['download']['theme_id']}}
    };
    this.eService.duplicatedownloadSetting = this.downloadSetting;
    this.eService.downloadSetting = JSON.parse(JSON.stringify(this.downloadSetting));
    this.repoService.saveDownloadSettings(body).subscribe(
      result =>{
        if (result["status"] == 1) {
        this.notifier.notify("success","Theme uptated successfully");
        }else{
          this.notifier.notify("error","Something went wrong!")
        }
      }
    )
  }

}
